module.exports = __webpack_public_path__ + "img/Recipe-366JieYang.1795844b.png";